import { compose } from 'redux';
import context from './context';
import env from '../env';

export function composeBuilder(
  window = context // eslint-disable-line no-unused-vars
) {
  return env.PUSHBOT_REDUX_DEVTOOLS !== 0 &&
    typeof context === 'object' &&
    context.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? context.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;
}



// WEBPACK FOOTER //
// ./js/util/compose.js